<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6jstYq/tc-custom/9781488030475.jpg?1726519168258" alt="This image is the cover for the book Ace of Shades, The Shadow Game Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ace of Shades, The Shadow Game Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A teenage girl goes searching for her mother in the City of Sin in this YA fantasy from the <i>New York Times</i>–bestselling coauthor of <i>All of Us Villains.</i></b><br/><br/>Welcome to New Reynes, the so-called City of Sin, where casino families reign, gangs infest the streets . . . and secrets hide in every shadow. It’s no place for a properly raised young lady. But when her mother goes missing, Enne Salta leaves her finishing school—and her reputation—behind. Following her mother’s trail, she finds herself in the city where no one survives uncorrupted.<br/><br/>Frightened and alone, Enne’s only clue leads her to Levi Glaiyser—a street lord and con man in desperate need of the compensation Enne offers. Their search sends this unlikely duo through glamorous casinos, illicit cabarets, and into the clutches of a ruthless Mafia donna. But as Levi’s enemies close in on them, a deadly secret from Enne’s past comes to light and she must surrender herself to the City of Sin —to a vicious game of execution . . . <br/><br/>Where the players never win.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Foody
      </h2>
      
      <p class="authorDescription body article">Amanda Foody has always considered imagination to be our best attempt at magic. After spending her childhood longing to attend Hogwarts, she now loves to write about immersive settings and characters grappling with insurmountable destinies. She holds a master's in accountancy from Villanova University and a bachelor of arts in English literature from the College of William and Mary.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16361e8c